import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=52668260&scoped=true&"
var script = {}
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=52668260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52668260",
  null
  
)

export default component.exports